import { BaseComponent } from '@app/core/abstract-classes/baseComponent';
import { Input, Component, Output, EventEmitter } from '@angular/core';

import { InfoBarContent, InfoBarActionEnums } from './informative-bar-utils';

@Component({
  selector: 'informative-bar',
  templateUrl: 'informative-bar.component.html',
  styleUrls: ['./informative-bar.component.scss'],
  standalone: false,
})
export class InformativeBarComponent extends BaseComponent {
  @Output() actionSelected = new EventEmitter<InfoBarActionEnums>();
  @Input() cssClassName: string;
  @Input() content: InfoBarContent[];
  @Input() showInfoBar: boolean;

  handleActionClick(action: InfoBarActionEnums): void {
    this.actionSelected.emit(action);
  }
}
